<template>
  <div class="col-12 p-3">
    <a
      class="btn btn-default btn-md"
      @click="openModal('#' + modalId)"
    >
      {{ buttonText }}
    </a>
    <v-modal
      :id="modalId"
      :size="modalSize"
    >
      <div class="text-center">
        <p class="mb-5">
          {{ modalDetailText }}
        </p>
        <div>
          <button
            class="btn btn-outline-gray btn-dialog mr-0 mr-sm-2 mb-3 mb-sm-0 text-dark-gray"
            data-dismiss="modal"
            aria-label="Close"
          >
            {{ t("cancel") }}
          </button>
          <button
            class="btn btn-danger btn-dialog"
            :class="{ 'disabled': disabledFlg }"
            @click="submit"
          >
            {{ t("cancel_membership_application") }}
          </button>
        </div>
      </div>
    </v-modal>
  </div>
</template>

<script>
import VModal from "./VModal.vue";
import I18n from "../i18n/i18n";
import "../i18n/ja";
import { i18n } from "../mixins/i18n";

export default {
  components: {
    VModal
  },
  mixins: [i18n],
  props: {
    modalId: {
      type: String,
      required: true
    },
    modalSize: {
      type: String,
      default: "sm"
    },
    modalDetailText: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      disabledFlg: false
    };
  },
  methods: {
    openModal(id) {
      // モーダルを開く
      $(id).modal();
    },
    submit() {
      this.disabledFlg = true;
    }
  }
};
</script>
